import { toast } from 'react-toastify';
import { Toast, ToastType } from 'common/toast';

export const showToastError = (
  message: string = 'Lo sentimos ha ocurido un error en el servicio. Intente nuevamente.',
) => {
  show('error', message);
};

export const showToastInfo = (message: string) => {
  show('info', message);
};

export const showToastSuccess = (message: string) => {
  show('success', message);
};

export const showToastWarning = (message: string) => {
  show('warning', message);
};

export const show = (type: ToastType, message: string) => {
  toast(<Toast message={message} type={type} />);
};

export const showGenericErrorMessage = () => {
  showToastError();
};
